import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { DashboardLayoutProvider } from './context/DashboardLayoutContext';
import { FeatureFlagsProvider } from './context/FeatureFlagsContext';
import { HelmetProvider } from 'react-helmet-async';
import { captureAttribution } from './utils/attribution';
import { trackEvent } from './api/analyticsService';
import { adoptSsrPage } from './utils/ssrPage';

captureAttribution();
// Before React mounts, so it never sees the server-rendered share page's head tags.
adoptSsrPage();

// Records a tap on a web push notification (backs the admin Notifications
// page's tap rate). The service worker can't call the API itself — it passes
// the tap here, either as a message to an open tab or as a query param on a
// tab it opened (stripped again so a reload doesn't count twice).
function trackNotificationOpens() {
    const params = new URLSearchParams(window.location.search);
    const opened = params.get('notification_opened');
    if (opened) {
        trackEvent('notification_opened', { type: opened });
        params.delete('notification_opened');
        const query = params.toString();
        window.history.replaceState(null, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
    }
    navigator.serviceWorker?.addEventListener('message', (event) => {
        if (event.data?.kind === 'notification_opened') {
            trackEvent('notification_opened', { type: String(event.data.type || 'unknown') });
        }
    });
}

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    });
    trackNotificationOpens();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <FeatureFlagsProvider>
              <DashboardLayoutProvider>
                <App />
              </DashboardLayoutProvider>
            </FeatureFlagsProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

